/**
 * Horizontal filter controls for the dashboard.
 * Reads available sites/observers from the unfiltered dataset.
 */

import { useDashboardContext } from '@/components/layout/DashboardShell';
import { uniqueSites, uniqueObservers } from '@/lib/dashboard/aggregations';
import { Filter, RefreshCw } from 'lucide-react';

export function DashboardFilterBar() {
  const { all, filtered, filters, setFilters, refetch, fetchedAt } = useDashboardContext();
  const sites = uniqueSites(all);
  const observers = uniqueObservers(all);

  return (
    <div className="border-b bg-background/80 backdrop-blur">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3 px-6 py-2.5">
        <Filter className="h-4 w-4 text-muted-foreground" />

        <label className="flex items-center gap-1.5 text-xs text-muted-foreground">
          From
          <input
            type="date"
            value={filters.from}
            onChange={(e) => setFilters({ from: e.target.value })}
            className="rounded-md border bg-background px-2 py-1 text-xs"
          />
        </label>

        <label className="flex items-center gap-1.5 text-xs text-muted-foreground">
          To
          <input
            type="date"
            value={filters.to}
            onChange={(e) => setFilters({ to: e.target.value })}
            className="rounded-md border bg-background px-2 py-1 text-xs"
          />
        </label>

        <label className="flex items-center gap-1.5 text-xs text-muted-foreground">
          Site
          <select
            value={filters.sites.length === 1 ? filters.sites[0] : ''}
            onChange={(e) =>
              setFilters({ sites: e.target.value ? [e.target.value] : [] })
            }
            className="rounded-md border bg-background px-2 py-1 text-xs"
          >
            <option value="">All sites</option>
            {sites.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </label>

        <label className="flex items-center gap-1.5 text-xs text-muted-foreground">
          Observer
          <select
            value={filters.observer}
            onChange={(e) => setFilters({ observer: e.target.value })}
            className="rounded-md border bg-background px-2 py-1 text-xs"
          >
            <option value="">All observers</option>
            {observers.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </select>
        </label>

        <div className="ml-auto flex items-center gap-3">
          <span className="text-xs text-muted-foreground">
            {filtered.length} of {all.length} obs
          </span>
          <button
            onClick={refetch}
            title={fetchedAt ? `Last fetched ${new Date(fetchedAt).toLocaleTimeString()}` : 'Refresh'}
            className="rounded-md p-1 text-muted-foreground hover:bg-muted hover:text-foreground"
          >
            <RefreshCw className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
